export type PrintStoryDoc = {
  id: string
  [key: string]: any
}

export type PrintStoryLane =
  | 'content'
  | 'code'
  | 'render'
  | 'prefetch'
  | 'print'
  | 'callback'
  | 'printer_health'
  | 'connection'
  | 'mail'

export type PrintStoryKind =
  | 'content_created'
  | 'code_assigned'
  | 'mail_sent'
  | 'render_started'
  | 'render_completed'
  | 'render_failed'
  | 'heartbeat_ok'
  | 'heartbeat_stale'
  | 'heartbeat_missing_started'
  | 'heartbeat_recovered'
  | 'status_issue_opened'
  | 'status_issue_resolved'
  | 'connection_connected'
  | 'connection_disconnected'
  | 'job_created'
  | 'job_published'
  | 'job_publish_failed'
  | 'job_blocked'
  | 'job_completed'
  | 'job_failed'
  | 'job_callback_missing'
  | 'callback_received'

export type PrintStorySeverity = 'success' | 'info' | 'warning' | 'danger' | 'neutral'

export type BackendSeverity = 'normal' | 'info' | 'attention' | 'error' | 'connectivity'

export type PrintStoryEvent = {
  ts: number
  endTs?: number | null
  lane: PrintStoryLane
  laneKey?: string
  kind: PrintStoryKind
  severity: PrintStorySeverity
  deviceId?: string
  jobId?: string
  contentId?: string
  codeId?: string
  title: string
  detail?: string
  sourceCollection: string
  raw: unknown
}

export type TimeWindowMs = {
  startMs: number
  endMs: number
}

export type PrinterStoryKpis = {
  uptimePercent: number
  incidentCount: number
  totalDowntimeMs: number
  mtbfMs: number | null
  mttrMs: number | null
  lastIncident: {
    startedAtMs: number
    endedAtMs: number | null
    resolved: boolean
    type?: string
    reason?: string
  } | null
}

export type MishapBlockedJobsCorrelation = {
  mishapId: string
  startedAtMs: number
  endedAtMs: number
  blockedJobCount: number
  blockedJobIds: string[]
}

export const HEARTBEAT_FRESH_MS = 30_000
export const HEARTBEAT_STALE_MS = 90_000
export const HEARTBEAT_HARD_INCIDENT_MS = 180_000

export const BACKEND_SEVERITY_COLOR: Record<BackendSeverity, string> = {
  normal: 'success',
  info: 'primary',
  attention: 'warning',
  error: 'danger',
  connectivity: 'danger',
}

export const JOB_STATUS_SEVERITY: Record<string, PrintStorySeverity> = {
  completed: 'success',
  failed: 'danger',
  blocked: 'danger',
  callback_missing: 'danger',
  published: 'warning',
  pending: 'neutral',
}
